import script from "./PCPartsNavbar.vue?vue&type=script&setup=true&lang=js"
export * from "./PCPartsNavbar.vue?vue&type=script&setup=true&lang=js"

import "./PCPartsNavbar.vue?vue&type=style&index=0&id=043c3372&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-043c3372"]])

export default __exports__